import React, { useEffect } from "react";
import styles from "../../styles/layout/Qc-dashboard-wrapper.module.scss";
import { Box, Stack } from "@mui/material";
import QcDashboardheader from "../Header/QcDashboardheader";
import QcDashboardSidebar from "../Sidebar/QcDashboardSidebar";
import { parseCookies } from "nookies";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useQuery } from "react-query";
import {
  // setAcquisitors,
  // setInquirers,
  // setManagers,
  // setSubmission,
  // setQualityTeam,
  // setContentBuyers,
  // setCompanies,
  setQcSubmission,
} from "../../redux-toolkit/slices/app.state.slice";
// import { fetchManagers } from "../../api/functions/manager.api";
import { useAppDispatch } from "../../hooks/useAppDispatch";
// import { fetchAcquisitors } from "../../api/functions/acquisitor.api";
import { qcSubmissionsList } from "../../api/functions/cms.api";
import { setLoginData } from "../../redux-toolkit/slices/userSlice";
import { getQcProfileDetails } from "../../api/functions/qc.api";

const QcDashboardWrapper = (props) => {
  const cookies = parseCookies();

  const nav = useNavigate();

  const token = cookies?.token;
  const savedrole_Id = cookies?.role_id;
  const enabled = token ? true : false;

  const { qcSubmisson } = useAppSelector((s) => s.appStateSlice);
  const { userData } = useAppSelector((s) => s.userSlice);
  const dispatch = useAppDispatch();

  //   console.warn("managers", managers);

  useEffect(() => {
    if (savedrole_Id != 6) {
      //   <Navigate to="/page404" />;
      // nav("/page404");
      nav("/login");
    }
  }, [savedrole_Id]);

  //   useQuery(["qc_acquisitor", enabled, acquisitors], () => fetchAcquisitors(), {
  //     // Using the onSuccess callback
  //     onSuccess: (data) => {
  //       // console.warn("Data fetched successfully:", data);
  //       dispatch(setAcquisitors(data));
  //       // You can perform additional actions here with the fetched data
  //     },
  //     enabled: enabled && !acquisitors,
  //   });

  //   useQuery(["qc_managers", enabled], () => fetchManagers(), {
  //     // Using the onSuccess callback
  //     onSuccess: (data) => {
  //       // console.warn("managers fetched successfully:", data);
  //       dispatch(setManagers(data));
  //       // You can perform additional actions here with the fetched data
  //     },
  //     enabled: enabled && !managers,
  //   });

  //   console.warn("test", !qcSubmisson, savedrole_Id == 6, enabled);

  useQuery(
    ["qcSubmissionsList", enabled, savedrole_Id, qcSubmisson],
    qcSubmissionsList,
    {
      onSuccess: (res) => {
        // console.warn("qcSubmissionsList", res);
        dispatch(setQcSubmission(res.data));
      },
      enabled:
        enabled &&
        (savedrole_Id == 6 ? true : false) &&
        (!qcSubmisson ? true : false),
    }
  );

  useQuery(
    ["getQcProfile", savedrole_Id, userData],
    async () => getQcProfileDetails(),
    {
      onSuccess: (res) => {
        // console.warn("res", res);
        dispatch(setLoginData(res));
      },
      enabled: (savedrole_Id == 6 ? true : false) && (!userData ? true : false),
    }
  );

  return (
    <>
      <QcDashboardheader />
      <Stack direction={"row"} className={styles.editorDashboardSiderbarBody}>
        <Box className={styles.editorDashboardSidebar}>
          <QcDashboardSidebar />
        </Box>
        <Box className={styles.editorDashboardBody}>{props.children}</Box>
      </Stack>
    </>
  );
};

export default QcDashboardWrapper;
